(function ($, Drupal) {
  $(document).ready(function () {
    $('.map-wrapper .text .button').click(function () {
      var script = document.createElement('script');
      script.onload = function () {

        $(document).ready(function () {
          initMap();
        });

      };
      script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyD7t4-ALYjDDk3MEU5ecA4_HhMdAea4aJw";

      document.head.appendChild(script);
    });
  });
})(jQuery, Drupal);

var initMap = function () {
  (function ($, Drupal) {
    if (google) {
      if (document.getElementById('map')) {
        var map;
        map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: -34.397, lng: 150.644},
          zoom: 8,
          maxZoom: 12,
          styles: [{
            "elementType": "geometry.fill",
            "stylers": [{"weight": "2.00"}]
          }, {
            "elementType": "geometry.stroke",
            "stylers": [{"color": "#4e4e4e"}]
          }, {
            "elementType": "labels.text",
            "stylers": [{"visibility": "on"}]
          }, {
            "featureType": "administrative.country",
            "elementType": "geometry.stroke",
            "stylers": [{"color": $('.map-wrapper.aktionen').length > 0 ? "#4c6b84" : "#084a90"}, {"weight": "2"}]
          }, {
            "featureType": "administrative.country",
            "elementType": "labels.text",
            "stylers": [{"visibility": "off"}]
          }, {
            "featureType": "administrative.locality",
            "elementType": "labels",
            "stylers": [{"lightness": "-79"}, {"weight": "2.20"}]
          }, {
            "featureType": "administrative.locality",
            "elementType": "labels.text",
            "stylers": [{"weight": 1}]
          }, {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [{"color": "#000000"}]
          }, {
            "featureType": "administrative.locality",
            "elementType": "labels.text.stroke",
            "stylers": [{"color": "#fff"}, {"weight": "4"}]
          }, {
            "featureType": "administrative.province",
            "elementType": "geometry.stroke",
            "stylers": [{"color": $('.map-wrapper.aktionen').length > 0 ? "#4c6b84" : "#084a90"}, {"weight": "1.00"}]
          }, {"featureType": "landscape", "stylers": [{"color": "#f2f2f2"}]}, {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#fff"}]
          }, {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#fff"}]
          }, {"featureType": "poi", "stylers": [{"visibility": "off"}]}, {
            "featureType": "road",
            "stylers": [{"saturation": -100}, {"lightness": 45}]
          }, {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#eee"}]
          }, {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [{"color": "#7b7b7b"}]
          }, {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [{"color": "#fff"}]
          }, {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{"visibility": "off"}]
          }, {
            "featureType": "road.highway",
            "stylers": [{"visibility": "simplified"}]
          }, {
            "featureType": "road.highway",
            "elementType": "labels",
            "stylers": [{"visibility": "off"}]
          }, {
            "featureType": "road.highway",
            "elementType": "labels.text",
            "stylers": [{"visibility": "off"}]
          }, {"featureType": "transit", "stylers": [{"visibility": "off"}]}, {
            "featureType": "water",
            "stylers": [{"color": $('.map-wrapper.aktionen').length > 0 ? "#dce9f6" : "#46bcec"}, {"visibility": "on"}]
          }, {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [{"color": $('.map-wrapper.aktionen').length > 0 ? "#dce9f6" : "#084a90"}]
          }, {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [{"color": "#070707"}]
          }, {
            "featureType": "water",
            "elementType": "labels.text.stroke",
            "stylers": [{"color": "#fff"}]
          }]
        });
        if (globalPins && globalPins.length > 0) {
          var bounds = new google.maps.LatLngBounds();

          var image = {
            url: '/themes/custom/nsb/images/pin.png',
            // This marker is 20 pixels wide by 32 pixels high.
            //size: new google.maps.Size(24, 31),
            scaledSize: new google.maps.Size(36, 44),
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(18, 34)
          };

          var markers = [];
          var gmarkers = [];

          globalPins.forEach(function (pin) {

            // if (pin.latlong != "") {
            if (pin.latlong != "" && (($('.map-wrapper.aktionen').length > 0 && pin.bundesland !== "bundesweit") || $('.map-wrapper.aktionen').length <= 0)) {
              var marker;
              var beforeInfobox = "";
              var contentString = "";
              var markerCount = 1;
              for (var i = 0; i < markers.length; i++) {
                if (pin.latlong[0] == markers[i].pos[0] && pin.latlong[1] == markers[i].pos[1]) {
                  markers[i].marker.setMap(null);
                  beforeInfobox += markers[i].infobox;
                  markerCount++;
                }
              }

              if ($('.map-wrapper.aktionen').length > 0) {
                marker = new google.maps.Marker({
                  position: new google.maps.LatLng(pin.latlong[0], pin.latlong[1]),
                  map: map,
                  icon: {
                    url: '/themes/custom/nsb/images/Karte_Pin.svg',
                    // This marker is 20 pixels wide by 32 pixels high.
                    //size: new google.maps.Size(24, 31),
                    scaledSize: new google.maps.Size(28, 34),
                    // The origin for this image is (0, 0).
                    origin: new google.maps.Point(1, 0),
                    // The anchor for this image is the base of the flagpole at (0, 32).
                    anchor: new google.maps.Point(14, 34),
                    labelOrigin: new google.maps.Point(13, 12),
                  },
                  label: markerCount > 1 ? {text: markerCount.toString(), color: "white"} : "",
                });
                contentString = '<div class="content">' +
                  '<h3 class="secondHeading">' + pin.kurztitle + '</h3>' +
                  '<h2 class="firstHeading">' + pin.title + '</h2>' +
                  '<div id="bodyContent">' +
                  '<a href="/node/' + pin.nid + '">' +
                  'zur Aktion</a> ' +
                  '</div>' +
                  '</div>';
              }
              else {
                marker = new google.maps.Marker({
                  position: new google.maps.LatLng(pin.latlong[0], pin.latlong[1]),
                  icon: image,
                  animation: google.maps.Animation.DROP,
                  map: map,
                });
                contentString = '<div class="content">' +
                  '<h3 class="secondHeading">' + pin.kontaktperson + '</h3>' +
                  '<h2 class="firstHeading">' + pin.stiftung + '</h2>' +
                  '<div id="bodyContent">' +
                  '<a href="/node/' + pin.nid + '">' +
                  'zum Steckbrief</a> ' +
                  '</div>' +
                  '</div>';
              }

              var markerInfo = {
                "marker": marker,
                "pos": [pin.latlong[0], pin.latlong[1]],
                "infobox": contentString
              };

              var infowindow = new google.maps.InfoWindow({
                content: beforeInfobox + contentString
              });
              marker.addListener('click', function () {
                infowindow.open(map, marker);
              });

              markers.push(markerInfo);
              gmarkers.push(marker);

              bounds.extend(marker.getPosition());
            }
          });

          map.fitBounds(bounds);
          var listener = google.maps.event.addListener(map, "idle", function () {
            if (map.getZoom() > 15) {
              map.setZoom(15);
            }
            google.maps.event.removeListener(listener);
          });

          // Add a marker clusterer to manage the markers.
          new MarkerClusterer(map, gmarkers, {
            imagePath:
              "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
            maxZoom: 11
          });

          $('.tabulators .item').click(function () {
            setTimeout(function () {
              map.fitBounds(bounds);
              var listener = google.maps.event.addListener(map, "idle", function () {
                if (map.getZoom() > 15) {
                  map.setZoom(15);
                }
                google.maps.event.removeListener(listener);
              });
            }, 1);
          });
        }
      }
    }
  })(jQuery, Drupal);
};
